import { render, staticRenderFns } from "./SubscribeFormLinkGenerator.vue?vue&type=template&id=224ab138&scoped=true"
import script from "./SubscribeFormLinkGenerator.vue?vue&type=script&lang=js"
export * from "./SubscribeFormLinkGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224ab138",
  null
  
)

export default component.exports